/**
 * ClientOS structured error codes.
 *
 * IMPORTANT:
 * - Existing error codes are LOCKED and must not be modified.
 * - New codes may be added only when no existing code covers the failure.
 */

import { INIT_ERROR_CODES } from './InitErrorCodes';
import { THIRD_PARTY_ERROR_CODES } from './ThirdPartyErrorCodes';
import { OPERATION_ERROR_CODES } from './OperationErrorCodes';

export { INIT_ERROR_CODES } from './InitErrorCodes';
export { THIRD_PARTY_ERROR_CODES } from './ThirdPartyErrorCodes';
export { OPERATION_ERROR_CODES } from './OperationErrorCodes';

/* ──────────────────────────────────────────────────────────────────────────
 * Canonical export
 * ────────────────────────────────────────────────────────────────────────── */
export const ClientOSErrorCodes = {
  ...INIT_ERROR_CODES,
  ...THIRD_PARTY_ERROR_CODES,
  ...OPERATION_ERROR_CODES
} as const;

export type ClientOSErrorCode =
  (typeof ClientOSErrorCodes)[keyof typeof ClientOSErrorCodes];
